import { defineStore } from 'pinia'
import { createPersistConfig } from '@/store/PersistHelper'

export const useOperationStore = defineStore('operation', {
  state: () => ({
    keyOperation: null,
    loading: false,
    loadingMessage: 'Generando clave, por favor espera...',
  }),
  actions: {
    setKey(value) {
      this.keyOperation = value
    },
    setLoading(value, message = 'Generando clave, por favor espera...') {
      this.loading = value
      this.loadingMessage = message
    },
  },
  getters: {
    getKey: (state) => state.keyOperation
  },
  persist: createPersistConfig('operation'),
})